/**
 * Jarvis (pages/Jarvis.tsx, the Agency overview box, Settings → Jarvis): types, starter
 * questions and labels. Only erasable types, so node --test loads this file directly.
 */
export type JarvisAction = { type: "task"; id: number; title: string; assigned_to?: number; client_id?: number | null; due_date?: string | null; to: string };
export type JarvisMessage = {
  id: number | string; role: "user" | "assistant"; content: string; created_at?: string;
  steps?: string[]; actions?: JarvisAction[]; provider?: string | null; model?: string | null; failed?: boolean;
};
export type JarvisEvent =
  | { type: "ping" }
  | { type: "session"; id: number; title?: string }
  | { type: "step"; label: string }
  | { type: "action"; action: JarvisAction }
  | { type: "provider"; provider: string; model: string }
  | { type: "done"; message: JarvisMessage }
  | { type: "error"; error: string };
export type JarvisChoice = { id: "claude" | "openai"; label: string; model: string; connected: boolean; via: string | null };
export type JarvisSettings = { provider: JarvisChoice["id"]; choices: JarvisChoice[] };

export const JARVIS_STARTERS = [
  "Which clients need attention this week, and why?",
  "How did ad spend and leads do across the agency in the last 30 days?",
  "What is on my plate today?",
  "What is waiting for approval?",
];

/** The AI that wrote a reply, in words: "Claude" or "OpenAI". */
export function providerLabel(provider?: string | null, model?: string | null) {
  if (provider === "openai" || /^(gpt|o\d)/i.test(model || "") || /^openai\//.test(model || "")) return "OpenAI";
  if (provider === "anthropic" || /claude/i.test(model || "")) return "Claude";
  return provider === "openrouter" ? "OpenRouter" : provider || "";
}

/** The Jarvis page URL that asks a question as it opens. */
export const askJarvis = (question: string) => `/jarvis?ask=${encodeURIComponent(question.trim())}&go=1`;
